import { ComponentProps } from "../registry";
import { useBound } from "../helpers";
import { formatText } from "../../path";
import { BoundValue } from "../../types";
import { NestedValue } from "../NestedValue";

export function Text({ fields, scope }: ComponentProps) {
  const text = useBound(fields.text as BoundValue, scope);
  const usage = useBound<string>(fields.usageHint as BoundValue, scope) ?? "body";

  // Complex bound values (objects / arrays) get product-grade nested
  // rendering — key/value rows, chips, count summaries. Never raw JSON.
  if (text !== null && typeof text === "object") {
    return (
      <div className={`a2-text use-${usage}`}>
        <NestedValue value={text} />
      </div>
    );
  }
  // Scalars (and null → empty, so error/caption placeholders stay blank).
  return (
    <p className={`a2-text use-${usage}`}>{formatText(text)}</p>
  );
}
